module.exports = __webpack_public_path__ + "static/media/heartFilled.0e07d10c.svg";